/**
 * Короткий код слепка. Не сумма ставки: в буфер не писать.
 */

const HOLD_MS = 800;

let timer: number | null = null;
let current: string | null = null;
const listeners = new Set<(code: string | null) => void>();

export function flashCode(code: string): void {
  current = code;
  listeners.forEach((fn) => fn(code));
  if (timer !== null) window.clearTimeout(timer);
  timer = window.setTimeout(() => {
    current = null;
    timer = null;
    listeners.forEach((fn) => fn(null));
  }, HOLD_MS);
}

export function onFlash(fn: (code: string | null) => void): () => void {
  listeners.add(fn);
  fn(current);
  return () => {
    listeners.delete(fn);
  };
}

/** Тесты не оставляют чужой тост. */
export function resetFlash(): void {
  if (timer !== null) window.clearTimeout(timer);
  timer = null;
  current = null;
  listeners.forEach((fn) => fn(null));
}
